import { render } from "./SaleSharedHistoryTab.vue?vue&type=template&id=69c5053a"
import script from "./SaleSharedHistoryTab.vue?vue&type=script&lang=js"
export * from "./SaleSharedHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__